<template>

  <div class="predictions-container">
    <!-- Navigation Tabs -->
    <nav class="nav-tabs">
      <button v-for="tab in tabs" :key="tab.id" :class="['tab', { active: activeTab === tab.id }]"
        @click="switchTab(tab.id)">
        {{ tab.label }}
      </button>
    </nav>

    <!-- Main Content -->
    <main class="main-content">
      <div class="predictions-list">
        <PredictionCard v-for="prediction in displayedPredictions" :key="prediction.id" :prediction="prediction"
          @vote="handleVote" />
      </div>

      <!-- Trade Card Component 
      <TradeCard v-if="showTradeCard && selectedPrediction" :prediction="selectedPrediction"
        :market-id="selectedPrediction.id" :preSelectedChoice="selectedVote" />
      --> 
      <!-- <div class="load-more-container">
        <button class="load-more-btn" @click="loadMore">Загрузить еще</button>
      </div> -->
    </main>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import PredictionCard from '../components/PredictionCard.vue';
import TradeCard from '../components/TradeCard.vue';
import { apiClient } from '../api/client';
import { useRouter } from 'vue-router';


// Define constant for initial visible count

export default {
  name: 'PredictionCardsList',
  components: {
    PredictionCard,
    TradeCard
  },
  props: {
    initialVisibleCount: {
      type: Number,
    }
  },
  emits: ['login'],
  setup(props, { emit }) {
    const router = useRouter();
    // State
    const activeTab = ref('trending');
    const visibleCount = ref(props.initialVisibleCount);
    const predictions = ref([]);
    const showTradeCard = ref(false);
    const selectedPrediction = ref(null);
    const selectedVote = ref(null);

    const tabs = ref([
      { id: 'trending', label: 'В тренде' },
      { id: 'new', label: 'Новые' }
    ]);

    function randomInteger(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function pickRandomValue(array) {
      return array[Math.floor(Math.random() * array.length)];
    }

    function getGradientForPrediction(percentage, id) {
      // Create a barely visible gradient using a random value based on id for consistency
      // Use the id to create a deterministic "random" value
      const angle = '135deg';

      const gradientStart = ["#f0f4ff", "#f0f8ff", "#f8fafc", "#f7fcf7", "#f8fafc", "#fdf8f8"];
      const gradientEnd = ["#e6ebff", "#e6f4ff", "#f0f7fc", "#f0faf0", "#fdf9f0", "#fdf0f0"];

      const start = pickRandomValue(gradientStart);
      const end = pickRandomValue(gradientEnd);

      return `white`;
    }

    // Fetch predictions from API based on tab
    const fetchPredictions = async (tabId) => {
      try {
        let endpoint = '/markets/new';
        if (tabId === 'new') {
          endpoint = '/markets/new';
        }
        const data = await apiClient.get(endpoint);
        // Assuming the API returns data in the format { content: [...] }
        const predictionsData = data.content || data;
        console.log(predictionsData);
        predictions.value = predictionsData.map(prediction => ({
          ...prediction,
          gradient: getGradientForPrediction(prediction.percentage, prediction.id)
        }));
        visibleCount.value = props.initialVisibleCount || 6; // Reset visible count when loading new data
      } catch (error) {
        console.error('Error fetching predictions:', error);
        // Fallback to mock data if API call fails
        predictions.value = [];
        predictions.value.forEach(prediction => {
          prediction.gradient = getGradientForPrediction(prediction.percentage);
        });
      }
    };

    // Computed
    const displayedPredictions = computed(() => {
      // Add gradient to each prediction for display while preserving all other properties
      return predictions.value.slice(0, visibleCount.value).map(prediction => {
        return {
          id: prediction.id,
          title: prediction.title,
          volume: prediction.volume,
          participants: prediction.participants,
          percentage: prediction.percentage,
          ordersCount: prediction.ordersCount | 0,
          gradient: getGradientForPrediction(prediction.percentage, prediction.id)
        };
      });
    });

    // Methods
    const switchTab = (tabId) => {
      activeTab.value = tabId;
      fetchPredictions(tabId);
    };

    const handleVote = (predictionId, vote) => {
      const prediction = predictions.value.find(p => p.id === predictionId);
      showTradeCard.value = true;
      selectedPrediction.value = prediction;
      selectedVote.value = vote;
      router.push({ name: "MarketView", params: { id: predictionId, selectedChoice: vote, toList: true } })
    };
    const loadMore = () => {
      visibleCount.value += 3;
      console.log('Loading more predictions...');
    };

    // Fetch initial predictions when component mounts
    onMounted(() => {
      fetchPredictions(activeTab.value);
    });

    return {
      activeTab,
      tabs,
      displayedPredictions,
      switchTab,
      handleVote,
      loadMore,
      showTradeCard,
      selectedPrediction, 
      selectedVote  
    };
  }
};
</script>


<style scoped>
.predictions-container {
  background-color: #f9fafb;
}

  
</style>